module.exports = __webpack_public_path__ + "static/media/cert_11.17abe3fc.jpg";